import { HttpContextToken } from '@angular/common/http';

export const NO_LOADING = new HttpContextToken(() => true);
